var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jd_supplement" },
    [
      _c("div", { staticClass: "page_title" }, [
        _vm._v("京东超级补贴活动对接"),
      ]),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content_box" },
        [
          _c(
            "div",
            { staticClass: "content_header" },
            [
              _c("div", { staticClass: "total_text" }, [
                _vm._v("\n        共"),
                _c("span", { staticClass: "num" }, [
                  _vm._v(_vm._s(_vm.tableData.length)),
                ]),
                _vm._v("个联盟信息\n      "),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.onAdd },
                },
                [_vm._v("添加联盟信息")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "accountId", label: "联盟ID", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "unionId", label: "应用 ID", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "appKey",
                  label: "应用 App Key",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "appSecret",
                  label: "应用 App Secret",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.onEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.onDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogType === "add" ? "添加联盟信息" : "编辑联盟信息",
            visible: _vm.dialogVisible,
            width: "720px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            closed: _vm.onDialogClosed,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.formData,
                rules: _vm.formRules,
                "label-width": "130px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "京东联盟 ID", prop: "accountId" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.formData.accountId,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "accountId", $$v)
                      },
                      expression: "formData.accountId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "应用 ID", prop: "unionId" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.formData.unionId,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "unionId", $$v)
                      },
                      expression: "formData.unionId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "应用 App Key", prop: "appKey" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入",
                      disabled: _vm.dialogType === "edit",
                    },
                    model: {
                      value: _vm.formData.appKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "appKey", $$v)
                      },
                      expression: "formData.appKey",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "应用 App Secret", prop: "appSecret" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.formData.appSecret,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "appSecret", $$v)
                      },
                      expression: "formData.appSecret",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saveLoading },
                  on: { click: _vm.onSave },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "tip_dialog",
          attrs: { title: "提示", visible: _vm.tipVisible, width: "380px" },
          on: {
            "update:visible": function ($event) {
              _vm.tipVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "tip_text" }, [
            _vm._v("当前联盟应用已被占用"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.tipVisible = false
                    },
                  },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tips_box" }, [
      _c("p", [
        _vm._v(
          "\n      1. App 上线京东超级补贴活动前，需将京东联盟创建的 App Key / App Secret\n      配置到当前对接页面，否则将导致活动商品无法获取补贴信息\n    "
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("2. 配置完成后不要随意编辑删除对接好的联盟信息！")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }